import { render, staticRenderFns } from "./KaiMessage.vue?vue&type=template&id=16577774&scoped=true&"
import script from "./KaiMessage.vue?vue&type=script&lang=ts&"
export * from "./KaiMessage.vue?vue&type=script&lang=ts&"
import style0 from "./KaiMessage.vue?vue&type=style&index=0&id=16577774&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16577774",
  null
  
)

export default component.exports